import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { SocialProofPopup } from './components/SocialProofPopup';
import { WhatsAppBubble } from './components/WhatsAppBubble';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './sections/HeroSection';
import { InclusionsSection } from './sections/InclusionsSection';
import { PainPointSection } from './sections/PainPointSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { FeaturesSection } from './sections/FeaturesSection';
import { FinalCTASection } from './sections/FinalCTASection';
import { ReviewsSection } from './sections/ReviewsSection';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('compra');
    if (!purchaseSection) return;
    const targetY = purchaseSection.getBoundingClientRect().top + window.scrollY;
    const startY = window.scrollY;
    const diff = targetY - startY;
    const duration = 1000;
    let startTime: number | null = null;
    const easeInOutCubic = (t: number) => t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    const step = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      window.scrollTo(0, startY + diff * easeInOutCubic(progress));
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  };
  return <div className="font-sans bg-white min-h-screen text-[#424E60] selection:bg-[#586880] selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <UrgencyBar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection onScrollToPurchase={scrollToPurchase} data-id="element-4" />
        <InclusionsSection onScrollToPurchase={scrollToPurchase} data-id="element-5" />
        <PainPointSection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <FeaturesSection data-id="element-8" />
        <FinalCTASection data-id="element-9" />
        <ReviewsSection data-id="element-10" />
      </main>

      <SocialProofPopup data-id="element-11" />
      <WhatsAppBubble data-id="element-12" />
    </div>;
}